export default "__VITE_ASSET__CBjcOqXW__"